import { Button, Card, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FC } from "react";

type Props = {};

export const SkillTracking: FC<Props> = () => {
  return (
    <Card title="Skill Tracking & Training">
      <Card
        type="inner"
        title="Forklift Certification"
        extra={<Tag color="green">3 Staff</Tag>}
      >
        <p>Next renewal: Aug 15, 2023</p>
        <a>View certified staff</a>
      </Card>
      <Card
        type="inner"
        title="OSHA-10"
        extra={<Tag color="green">2 Staff</Tag>}
        style={{ marginTop: 16 }}
      >
        <p>Next renewal: Oct 22, 2023</p>
        <a>View certified staff</a>
      </Card>
      <Button block style={{ marginTop: 16 }} icon={<PlusOutlined />}>
        Add New Certification
      </Button>
    </Card>
  );
};
